<template>
  <b-row class="TimesheetView">
    <b-col cols="12" lg="10" offset-lg="1">
      <Notification v-bind.sync="notification" />

      <TimesheetCard
        no-refresh
        no-submit
        :csv-btn="hasCSVData"
        @csvClick="generateCSV"
        :employee="userEmployeeData"
        :loadingEmployee="loadingTimesheetData"
        :timesheetData="timesheetData"
        :other-details="otherTimesheetData"
        :other-details-options="otherDetailsOptions"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import Notification from '@/components/Notification';
import TimesheetCard from '@/components/TimesheetCard';
import TimesheetService from '@/services/TimesheetService';
import timesheetStatuses from '@/mixins/timesheetStatuses';

const timesheet = new TimesheetService();

export default {
  name: 'TimesheetView',
  components: {
    Notification,
    TimesheetCard,
  },
  mixins: [timesheetStatuses],
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const { code } = vm.$route.params;

      vm.loadingTimesheetData = true;

      vm.startLoadingPage();
      vm.startLoadingRequest();
      timesheet.getTimesheetByKey(code, true)
        .then(vm.displayData)
        .then(() => {
          vm.stopLoadingRequest();
          vm.stopLoadingPage();
          vm.loadingTimesheetData = false;
        })
        .catch(() => {
          vm.setAlert({
            show: 5,
            variant: 'danger',
            fade: true,
            dismissible: true,
            message: 'An error occurred',
            icon: {
              name: 'exclamation',
            },
          });
        });
    });
  },
  data() {
    return {
      loadingTimesheetData: false,
      userEmployeeData: {},
      otherTimesheetData: {},
      timesheetData: [],
      timesheetStatus: {},
      formattedForCSV: [],
    };
  },
  computed: {
    statusVariant() {
      const { status_id: id } = this.timesheetStatus;
      switch (Number(id)) {
        case this.pendingApproval:
          return 'warning';
        case this.approved:
          return 'success';
        case this.rejected:
          return 'danger';
        default:
          return 'light';
      }
    },
    otherDetailsOptions() {
      const defaultOptions = {
        size: 'sm',
        readonly: true,
        modifiers: ['text-left-align'],
        options: {
          inputCol: true,
          labelColsLg: 4,
          labelColsSm: 4,
          labelCols: 12,
          inputCols: 12,
          inputColsSm: 8,
          inputColsLg: 7,
        },
      };
      const { status } = this.timesheetStatus;
      const currentStatus = this.$startCase(status);
      const fields = [
        {
          ...defaultOptions,
          key: 'cutoffPeriodFormatted',
          label: 'Cutoff Period',
          value: '',
        },
        {
          ...defaultOptions,
          label: 'Status',
          html: `<span class="badge badge-${this.statusVariant}">${currentStatus}</span>`,
        },
      ];

      return { fields, labelClass: 'font-weight-bold' };
    },
    hasCSVData() {
      return !this.$ie(this.formattedForCSV);
    },
    ...mapState(['notification']),
    ...mapGetters([
      'userData',
      'isLoadingRequest',
      'isLoadingPage',
    ]),
  },
  methods: {
    displayData(result) {
      if (typeof result === 'object' && result) {
        // Set the data for display
        const { user, timesheetStatus, timesheet: tsData } = result;
        const { data, ...otherData } = tsData;

        // format cutoff dates
        const cutoffDates = this.$get(otherData, 'cutoff_period', []);
        const cutoffPeriodFormatted = cutoffDates.map((codate, idx) => {
          const pattern = idx === 0 ? 'MMM DD' : 'DD YYYY';
          return this.$fd(codate, pattern);
        }).join(' - ');

        this.formattedForCSV = this.$get(result, 'csv', []);

        this.userEmployeeData = user;
        this.timesheetData = data;
        this.timesheetStatus = timesheetStatus;
        this.otherTimesheetData = Object.assign({}, { cutoffPeriodFormatted }, otherData);
      }
    },
    generateCSV() {
      // TODO: audit log per click

      // convert timesheet to csv data (formatted same as view)
      this.$fcsv(this.formattedForCSV, `timesheet-${Date.now()}.csv`);
    },
    ...mapActions([
      'setAlert',
      'resetAlert',
      'setNotification',
      'startLoadingRequest',
      'stopLoadingRequest',
      'startLoadingPage',
      'stopLoadingPage',
    ]),
  },
};
</script>
